import Card from '../card';
import style from './style.scss';

/**
 * The AboutPhotos component is used on the About page to show photos of the weather station
 * components with captions.
 *
 * props: none
 */

const AboutPhotos = () => (
	<Card cardTitle="Weather station photos" noMargin>
		<div class={style.about_box_photos}>
			<div class={style.about_photos_section}>
				<div class={style.about_photo_description}>Outdoor components</div>
				<div class={style.about_photo_container}>

					<img class={style.about_photo_image_half}
						 src="assets/img/station-iss-2018-600w.jpg"
						 alt="Main outdoor unit" />

					<img class={style.about_photo_image_half}
						 src="assets/img//station-anemometer-2018-600w.jpg"
						 alt="Anemometer" />

				</div>
			</div>

			<div class={style.about_photos_section}>
				<div class={style.about_photo_description}>Inside the tipping bucket rain gauge</div>
				<div class={style.about_photo_container}>
					<img class={style.about_photo_image}
						 src="assets/img/rain-gauge-inside-2018-1200w.jpg"
						 alt="Rain gauge tipping bucket" />
				</div>
			</div>

			<div class={style.about_photos_section}>
				<div class={style.about_photo_description}>Indoor receiver console</div>
				<div class={style.about_photo_container}>
					<img class={style.about_photo_image}
						 src="assets/img/station-console-2018-1200w.jpg"
						 alt="Weather station console" />
				</div>
			</div>
		</div>
	</Card>
);

export default AboutPhotos;



// WEBPACK FOOTER //
// ./components/about/about-photos.js